<template>
  <section>
    <div :class="['font-medium text-sm text-[#344054]', showSelected ? 'py-2' : '']" v-if="isLabel">
      <label :for="id" class="text-[#344054] text-[14px] font-medium">{{
          label
        }}
        <span v-if="showLabelBadge" class="bg-red-100 text-red-500 text-xs px-2 py-1 rounded-lg" >
                    {{labelBadgeText}}
                  </span>
      </label>
    </div>

    <div class="parent-wrapper" id="parent-wrapper" :class="[position]">
      <div
        :class="['dropdown', {open: isOpen, '!border-0 !p-0 !shadow-none !bg-transparent': !showSelected}]"
        @click="!disabled ? toggleDropdown($event) : ''"
      >
        <div
          v-if="showSelected"
          :class="[
            {
              disabled: disabled,
              'wrapper-error': error,
              'border border-gray-300 rounded-lg': !isOpen && !noOutline,

              'bg-white  !shadow-none': noOutline,
            },

            'wrapper',
          ]"
          :style="{ height: containerHeight, ...styles }"
        >
          <input
            class="w-full h-full outline-none focus:outline-none px-2 placeholder:text-sm"
            v-model="searchTerm"
            @input="handleSearch"
            :placeholder="disabled ? ' ' : labelPlaceholder"
            :disabled="disabled"
          />
          <button
            v-if="selectedOptions && showClearBtn"
            @click.stop="clearSelection"
            class="text-sm hover:bg-gray-100 w-max text-gray-700 ml-2 my-1 px-3 py-1 rounded-md text-no-wrap"
            form=""
          >
            {{ $t("Clear Selected".getTranslationKey()) }}
          </button>
          <div
            v-if="showAddMore"
            @click.stop="handleAddMore"
            class="cursor-pointer hover:bg-gray-100 w-max h-max py-1 px-[6px] rounded-full text-gray-700"
            @mouseenter="showaddBtnTooltip = true"
            @mouseleave="showaddBtnTooltip = false"
          >
            <div>
              <v-icon size="small" icon="mdi-plus" />
              <div
                v-if="showaddBtnTooltip"
                class="absolute right-10 bg-white p-2 rounded-lg text-xs shadow-md text-no-wrap z-[9999]"
              >
                <div
                  class="absolute w-2 h-2 bg-white -top-1 rotate-45 right-2"
                ></div>
                {{
                  isTranslation
                    ? $t(addMoreText.getTranslationKey())
                    : addMoreText
                }}
              </div>
            </div>
          </div>
          <div
            v-if="selectedOptions && showClearIcon"
            @click.stop="clearSelection"
            class="hover:bg-gray-100 w-max h-max p-1 px-[6px] rounded-full cursor-pointer text-gray-700"
            @mouseenter="showClearSelectionTooltip = true"
            @mouseleave="showClearSelectionTooltip = false"
          >
            <div>
              <v-icon size="small" icon="mdi-close"></v-icon>
              <div
                v-if="showClearSelectionTooltip"
                class="absolute right-2 bg-white p-2 rounded-lg text-xs shadow-md text-no-wrap z-[99999]"
              >
                <div
                  class="absolute w-2 h-2 bg-white -top-1 rotate-45 right-2 mx-auto"
                ></div>
                {{ $t("Clear Selected".getTranslationKey()) }}
              </div>
            </div>
          </div>
          <div v-if="showDropdownArrow">
            <v-icon :class="['transition-all duration-700 ease-in-out', isOpen ? 'rotate-180' : '']" icon="custom:expandIcon" />
          </div>
        </div>
        <p v-else class="cursor-pointer text-blue-500 hover:text-blue-600">{{labelPlaceholder || "Select option"}}</p>
        <div
          class="absolute right-0 flex mr-2 transform -translate-y-1/2 item-center top-1/2"
          v-if="error"
        >
          <v-icon size="20" icon="custom:errorIcon" />
        </div>
        <Teleport to="body">
          <div :id="id" class="mt-2 dropdown-list" v-show="isOpen" @click.stop>
            <div
              v-if="filteredOptions?.length > 0"
              id="dropdown-list"
              class="max-h-[200px] overflow-y-auto"
            >
              <div
                v-for="option in filteredOptions"
                :key="option?.value"
                @click.stop="
                  !disabledOptions.includes(option.value) &&
                    toggleOption(option)
                "
                :class="[
                  'dropdown-option',
                  {
                    selected: isSelected(option),
                    'text-gray-400': disabledOptions.includes(option.value),
                  },
                ]"
              >
                <div class="flex items-center">
                  <div v-if="showCheckbox">
                    <input
                      type="checkbox"
                      class="option-checkbox"
                      :id="'option-checkbox-' + option?.text"
                      :value="option?.value ? option?.value : modelValue?.value"
                      :checked="isSelected(option)"
                      @change="updateValue"
                    />
                  </div>

                  <div>
                    <label :for="'option-checkbox-' + option?.value" class="flex items-center gap-2">
                      {{
                        isTranslation
                          ? $t(getTranslatedStringKey(option?.text))
                          : option?.text
                            ? option?.text
                            : modelValue?.text
                      }}
                      <slot :name="option.value + '_option_status'" :item="option">
                      <span
                        class="status text-xs"
                        v-if="
                        statusColor &&
                        (option?.status === 'Unapproved' ||
                          option?.status === 'Pending')
                      "
                      >{{ $t("reference.pendingApproval") }}</span
                      >
                        <span
                          class="status text-xs"
                          v-if="statusColor && option?.status === 'Resident'"
                        >{{ $t("German Resident") }}</span
                        >

                        <span
                          class="text-xs status bg-orange-200 text-orange-500 px-2 rounded-lg"
                          v-if="showBadge && !option?.is_active"
                        >Inactive</span
                        >
                      </slot>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="justify-center py-2 d-flex align-center">
              <p>{{ $t("No data available"?.getTranslationKey()) }}</p>
            </div>
          </div>
        </Teleport>
      </div>
    </div>

    <p v-if="error" class="text-red-500 text-[14px]">
      {{ $t(`${errorMessage}`) }}
    </p>
  </section>
</template>

<script>
import {defineComponent} from "vue";
import {getTransString} from "@/services/helpers";

export default defineComponent({
  name: "SingleSelect",
  props: {
    id: {
      type: String,
      default: "single-select",
    },
    label: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    isLabel: {
      type: Boolean,
      default: true,
    },
    statusColor: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "Single select",
    },
    labelPlaceholder: {
      type: String,
      default: "",
    },
    searchPlaceholder: {
      type: String,
      default: "Search",
    },
    showAddMore: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    showClearIcon: {
      type: Boolean,
      default: false,
    },
    showClearBtn: {
      type: Boolean,
      default: false,
    },
    statuText: {
      type: String,
      default: "Pending Approval",
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    optionItems: {
      type: Object,
    },
    addMoreText: {
      type: String,
      default: "Add text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isTranslation: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object || String,
      default: null,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "This field is required",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    noOutline: {
      type: Boolean,
      default: false,
    },
    containerHeight: {
      type: String,
      default: "44px",
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    showDropdownArrow: {
      type: Boolean,
      default: true,
    },

    disabledOptions: {
      type: Array,
      default: () => [],
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
    showLabelBadge: {
      type: Boolean,
      default: false,
    },
    labelBadgeText: {
      type: String,
      default: "Disapproved",
    },
    showSelected: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      selectedOptions: this.modelValue,
      searchTerm: "",
      isOpen: false,
      error: false,
      searching: false,
      showaddBtnTooltip: false,
      showClearSelectionTooltip: false,
      position: "bottom",
      fillOpt: [],
      searchTimeout: null
    };
  },
  watch: {
    modelValue: {
      handler(val) {
        this.selectedOptions = val;
        this.updateSearchTerm(val);
      },
      immediate: true,
    },
    hasError(val) {
      this.error = val;
    },
    options() {
      this.updateSearchTerm(this.modelValue);
    },

    selectedOptions(val) {
      this.updateSearchTerm(val);
    }
  },
  computed: {
    isSelected() {
      return (option) => option?.value === this.selectedOptions;
    },
    filteredOptions() {
      if (this.searchTerm && this.searching) {
        return this.options?.filter(
          (option) => this.isTermIncludesSearch(option) === true
        );
      }

      return this.options;
    },
    displayText() {
      if (Array.isArray(this.options)) {
        return this.options?.find(
          (option) => option?.value === this.modelValue
        );
      }
      return {};
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    updateSearchTerm(val) {
      this.searchTerm = this.options?.find((option) => option?.value === val)?.text || null
    },
    handleSearch(event) {
      if(event.target.value) {
        this.searching = true
        this.isOpen = true
      } else {
        this.searching = false
      }
    },
    isTermIncludesSearch(option) {
      const term = this.searchTerm?.toLowerCase();
      if (!term) return true; // If no search term, include all options

      if (this.isTranslation) {
        const translatedText = this.$t(option?.text.getTranslationKey())?.toLowerCase();
        return translatedText?.includes(term);
      } else {
        return option?.text?.toLowerCase().includes(term);
      }
    },
    getTranslatedStringKey(field) {
      return getTransString(field);
    },
    activate() {
      alert("activate");
      return {
        background: "#ffffff",
        border: "1px solid #fdc6c2",
        "box-shadow":
          "0 1px 2px rgba(16, 24, 40, 0.05),0 0 0 4px rgba(139, 41, 35, 0.04)",
        "border-radius": "8px",
      };
    },
    toggleDropdown(event) {
      const windowHeight = window.innerHeight;
      const isDropdownInScope =
        event.currentTarget.getBoundingClientRect().top + 250 < windowHeight;
      const top =
        event.currentTarget.getBoundingClientRect().top +
        event.currentTarget.getBoundingClientRect().height;
      const bottom = windowHeight - event.currentTarget.getBoundingClientRect().bottom;
      const left = event.currentTarget.getBoundingClientRect().left;
      const dropDownElement = document.getElementById(this.id);

      if(!dropDownElement) return;

      dropDownElement.style = "";

      if (isDropdownInScope) {
        dropDownElement.style.top = `${top}px`;
      } else {
        dropDownElement.style.bottom = `${bottom + 50}px`;
      }

      dropDownElement.style.left = `${left}px`;
      dropDownElement.style.width = `${
        event.currentTarget.getBoundingClientRect().width
      }px`;


      this.isOpen = !this.isOpen;
      this.searching = false
    },
    toggleOption(option) {
      this.selectedOptions = this.returnObject ? option :  option.value;
      this.isOpen = false;
      this.error = false;
      this.returnObject
        ? this.$emit("update:modelValue", option)
        : this.$emit("update:modelValue", option.value);
    },

    clearSelection() {
      this.selectedOptions = "";
      this.$emit("update:modelValue", "");
      this.isOpen = false;
    },
    updateValue(option) {
      this.$emit("update:modelValue", option);
    },
    compareOptions(option1, option2) {
      return (
        option1?.value === option2?.value && option1?.text === option2?.text
      );
    },
    filterOptions() {
      this.isOpen = true;
    },
    closeDropdown(event) {
      if (!this.$el?.contains(event?.target)) {
        this.isOpen = false;
        this.updateSearchTerm(this.selectedOptions);
      }
    },
    preventDropdownClose(event) {
      event.stopPropagation();
    },
    handleAddMore() {
      this.$emit("add-More");
    },

  },
});
</script>

<style scoped>
.parent-wrapper {
  position: relative;
}

.wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 8px;
  padding: 5px;
  cursor: pointer;
  width: 100%;
  background: #ffff;
  overflow-y: auto;
  overflow-x: hidden;
}
.wrapper-error {
  border-color: red !important;
}

.dropdown-arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
  color: #333;
  font-size: 14px;
  transition: transform 0.3s;
}
.dropup-arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-53%);
  pointer-events: none;
  color: #333;
  font-size: 14px;
  transition: transform 0.3s;
}

.selected-item {
  display: flex;
  align-items: center;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  margin: 2px 3px;
  padding: 0 2px;
  color: #344054;
  height: 24px;
}

.selected-item span {
  margin-right: 4px;
}

.selected-item button {
  padding: 2px;
  background: none;
  border: none;
  cursor: pointer;

  color: #718096;
}

.dropdown-list {
  position: absolute;
  background-color: #fff;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;

  overflow-y: hidden;
  overflow-x: hidden;
  z-index: 9999;
  box-shadow: 0 4px 6px -2px rgba(16, 24, 40, 0.03),
  0 12px 16px -4px rgba(16, 24, 40, 0.08);
}

.dropdown-list .dropdown-option {
  padding: 4px;
  cursor: pointer;
}
.dropdown-option {
  padding-left: 12px !important;
}

.selected {
  background-color: #fbf7f6;
}

.dropdown-list .dropdown-option:hover {
  background-color: #f7fafc;
}

.option-checkbox,
.dropdown-list .dropdown-option {
  cursor: pointer;
}

.option-checkbox:hover,
.dropdown-list .dropdown-option:hover {
  background-color: #f7fafc;
}

/* Added styles */
.dropdown-option label {
  cursor: pointer;
  font-size: 14px;
}

.dropdown-list {
  pointer-events: all;
}

.dropdown-list.hide {
  display: none;
}

input[type="checkbox"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-left: 5px;
  width: 20px;
  height: 20px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  outline: none;
  transition: all 0.3s;
  position: relative;
  margin-right: 5px;
  margin-top: 5px;
}

input[type="checkbox"]:checked {
  background: #f4eae9;
  border-color: #ae6a65;
}

input[type="checkbox"]:checked::before {
  content: "✔";
  color: #ae6a65;
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.disabled {
  background: #fafafb;
  color: #667085;
  cursor: default;
}
.open {
  background: #ffffff;
  border: 1px solid #fdc6c2;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05),
  0 0 0 4px rgba(139, 41, 35, 0.04);
  border-radius: 8px;
}
.above .dropdown-options {
  bottom: 100%;
  top: auto;
}
.status {
  color: #b54708;
  text-align: center;
  padding: 2px 8px;
  width: 83px;
  height: 22px;
  background: #fffcf5;
  border-radius: 16px;
}
.top .dropdown-list {
  bottom: 100%;
  top: auto;
}

.bottom .dropdown-list {
  top: 100%;
  bottom: auto;
}
</style>
